module.exports = "<div class=\"ml-0\" >\n    <ContentLoader :primaryColor=\"dtPalette['grey-3']\" >\n        <rect x=\"0\" y=\"10\" rx=\"3\" ry=\"3\" width=\"400\" height=\"70\" />\n    </ContentLoader>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/containers/profile/loaders/profile-filter-loader/template.html
// module id = CMZS
// module chunks = 0